import axios from 'axios'
export const loginWithRefreshToken = async () => {
  const customAxios = axios.create()
  const userData = localStorage.getItem(process.env.VUE_APP_LSUSERDATAKEY) !== null ? JSON.parse(localStorage.getItem(process.env.VUE_APP_LSUSERDATAKEY)) : {}
  try {
    const response = await customAxios.post(`${process.env.VUE_APP_COMMON_URL}loginWithRefreshToken`, {
      grant_type: 'refresh_token',
      client_id: 1,
      client_secret: 123456,
      username: Object.prototype.hasOwnProperty.call(userData, 'email') ? userData.email : '',
      refresh_token: localStorage.getItem(process.env.VUE_APP_LSREFRESHTOKENKEY),
      request_from: 'clientApp'
    })
    return response
  } catch (error) {
    return error
  }
}
